import Vue from 'vue';
import { Provider } from "js/crossword/types";
import PopupButtons from "./PopupButtons";
import PopupContainer from "./PopupContainer";

export default Vue.extend({
  inject: [Provider.LOCALIZATION],
  props: {
    type: String,
  },
  render() {
    return (
      <PopupContainer customClasses={['popup--revealAdPopup']}>
        <div class='adPopup--content-wrapper' style='margin-bottom: 1.3em'>
          {
            this.type === "word"
              ? <div>{this.localization.get("This word was already revealed.")}</div>
              : <div>{this.localization.get("This letter was already revealed.")}</div>
          }
        </div>

        <PopupButtons buttons={[{
          label: this.localization.get("Resume"),
          onClick: () => this.$emit("close"),
        }]} />
      </PopupContainer>
    );
  },
});
